import React, { useEffect } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../jss_setup";
import { toast } from "react-toastify";
import { trainsErrorMsgs } from "../../errors";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useTrainsInitSearch } from "../../hooks/trains";
import { useSelector } from "react-redux";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";

const styles = createUseStyles({
  DeepTrainSearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ..._.get(props, "customStyles.DeepTrainSearch", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const DeepTrainSearch = ({ encoded_data }) => {
  const classes = styles({});

  const history = useHistory();
  const { initSearch } = useTrainsInitSearch();

  const source_entity = useSelector((state) =>
    _.get(state.WebsiteMetadata, "metadata.source_entity")
  );

  function onError() {
    toast.warning(trainsErrorMsgs.searchForm.init_search, { duration: 5000 });
    history.push("/");
  }

  var decoded_data = {};
  try {
    decoded_data = { ...JSON.parse(window.atob(encoded_data)) };
  } catch (error) {
    onError();
  }

  function onInitSearch(form) {
    initSearch(form);
  }

  useEffect(() => {
    if (!source_entity) {
      onError();
      return;
    }
    if (_.isEmpty(decoded_data)) {
      return;
    }
    onInitSearch(decoded_data);
  }, [encoded_data, source_entity]);

  return (
    <div className={classes.DeepTrainSearch}>
      <FullScreenLoader />
    </div>
  );
};
DeepTrainSearch.defaultProps = {
  encoded_data: "",
};
DeepTrainSearch.propTypes = {
  encoded_data: PropTypes.string.isRequired,
};
export default DeepTrainSearch;
